import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/envago/Button/Button';

interface OfflinePanelProps {
    // Retry the connection: clears the offline blocker so the live loop resumes (RETRY_CONNECTION).
    onRetry: () => void;
    // Leave the assistant entirely.
    onExit: () => void;
}

// Shown while the assistant has no working connection (blocker 'offline'). Unlike the previous
// text-only hint it gives the user a way out of the otherwise stuck state: retry, or leave.
const OfflinePanel = ({ onRetry, onExit }: OfflinePanelProps) => {
    const { t } = useTranslation();

    return (
        <div className={'absolute bottom-0 left-0 right-0 bg-white rounded-t-xl p-4 max-h-[60%] overflow-y-auto'}>
            <h3>{t('aiReading.offline.title')}</h3>
            <p data-testid="offline-description" className={'text-sm text-gray-600'}>
                {t('aiReading.offline.description')}
            </p>
            <div className={'flex flex-col gap-2 mt-3'}>
                <Button primary={true} block={true} onClick={onRetry}>
                    {t('aiReading.buttons.retry')}
                </Button>
                <Button secondary={true} ghost={true} block={true} onClick={onExit}>
                    {t('aiReading.buttons.exit')}
                </Button>
            </div>
        </div>
    );
};

export default OfflinePanel;
